import React from "react";
import {Divider} from "@material-ui/core";

const RiaContactWorkExperienceRow = ({work}) => {

    let dateRange = []

    if (work && work.start_date) {
        dateRange = [work.start_date, work.end_date ? work.end_date : 'Present']
        dateRange = dateRange.join(' - ')
    } else {
        dateRange = 'Undisclosed'
    }

    return (
        <div style={{display: 'flex', width: '100%', flexDirection: 'column'}}>
            <div style={{display: 'flex'}}>
                <div style={{marginRight: '50px'}}>{dateRange}</div>
                <div>{`${work.name} CRD #${work.crd_id} ${work.active ? '' : ' - Currently Not Registered'}`}</div>
            </div>
            <Divider orientation="horizontal" flexItem />
        </div>
    )
}
export default RiaContactWorkExperienceRow;